import { FieldType } from '@app/queryTyping';
import { isHiddenField } from '@app/common/configurable-wizards/utils';
import { PhoneItemFields } from '@app/widgets/contacts-and-settings/types';
import { Field, FieldInfoGroupField } from '@app/common/configurable-wizards';

export const transformFields = (field: FieldInfoGroupField, markAsPrimary?: boolean) => {
  let subFields = field.subFields as Field[];
  const phoneType = PhoneItemFields[field.id as keyof typeof PhoneItemFields];

  // Exclude extension for home phone group
  if (subFields && phoneType === PhoneItemFields.HomePhoneFieldGroup) {
    subFields = subFields.filter(
      (item) => item.id !== 'Extension',
    );
  }

  // Transform sub-fields for making primary
  if (markAsPrimary) {
    subFields = subFields.reduce((
      acc: Field[],
      curr,
    ) => [...acc, {
      ...(!isHiddenField(curr) ? {
        ...curr,
        type: FieldType.HIDDENFIELDINFO,
      } : {
        ...curr,
        // Always make value as primary
        sValue: curr.id === 'IsPrimary'
          // eslint-disable-next-line i18next/no-literal-string
          ? 'true'
          : curr.sValue,
      }),
    }], []);
  }

  return subFields;
};
